// extracted by mini-css-extract-plugin
export default {"headerSection":"tM1ISzioSL","pageTitle":"Rrj_NdmAlU","description":"xxqY27Wwmt","categoriesContainer":"pD6Bip8C_W"};